module.exports = __webpack_public_path__ + "media/icons/heart_path-69ff9e2f.png";